<!-- https://github.com/FranckFreiburger/vue-pdf/issues/327 -->
<template>
  <div>
    <pdf
      v-for="i in numPages"
      :key="i"
      :src="src"
      :page="i"
      :rotate="rotate"
    ></pdf>
  </div>
</template>
<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfViewer',
  components: {
    pdf,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    numPages: {
      type: Number,
      default: 1
    },
    rotate: {
      type: Number,
      default: 0
    },
  },
  errorCaptured() {
    return false
  }
}
</script>
